<template>
    <v-dialog
        width="60%"
        max-width="500"
        v-model="showDialog"
        persistent
    >
        <v-card>
            <v-card-title class="text-h6 primary darken-2 white--text">
                DELETE CONTACT
            </v-card-title>
            <v-card-text class="py-16">
                Are you sure you want to delete this contact?
                <div v-if="error" class="error--text font-weight-bold">There was an error deleting the contact.</div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="close(false)"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="error"
                    @click="deleteLead"
                    :loading="loading"
                    :disabled="loading"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DialogDeleteLead',
    props: ['lead', 'req'],
    data: () => ({
        loading: false,
        showDialog: true,
        error: false
    }),
    mounted: function() {
        
    },
    methods: {
        deleteLead: function() {
            console.log("lead", this.lead)
            if(this.lead == undefined)
                return
            
            this.loading = true
            this.req.delete(`user/lead/${this.lead.ID}`)
            .then(data => {
                this.loading = false
                if(data.success) {
                    this.error = false
                    this.close(true)
                } else {
                    this.error = true
                }
            })
        },
        close(deleted = false) {
            this.$emit('close', deleted)
        },
        
    }
}
</script>
